import React from 'react';
import { Link } from 'react-router-dom';

import styles from '../styles/TopHeaderLayout.module.css';
import WarningPanel from '../Components/WarningPanel';

export default function Help() {
  const scrollToSection = (id) => {
      const element = document.getElementById(id);
      if (element) {
          element.scrollIntoView({ block: 'start' });
      }
  };

  React.useEffect(() => {
    scrollToSection(window.location.hash);
  }, [window.location.hash])

  React.useEffect(() => {
      if (window.location.hash === '#safety') {
          scrollToSection('safety');
      }
  }, []);

  return (
    <div
      className={styles.helpWrapper}
    >
      <div
        className={styles.helpHeader}
      >
        <h2>Справка</h2>
        <ul>
            <li 
              onClick={() => {window.location.hash = 'info'}}
              className={window.location.hash === '#info' ? 'active' : ''}
            >
              Основная информация
            </li>
            <li 
              onClick={() => {window.location.hash = 'registration'}}
              className={window.location.hash === '#registration' ? 'active' : ''}
            >
              Как зарегистрироваться
            </li>
            <li 
              onClick={() => {window.location.hash = 'problems-with-code'}}
              className={window.location.hash === '#problems-with-code' ? 'active' : ''}
            >
              Что делать если не пришёл код?
            </li>
            <li 
              onClick={() => {window.location.hash = 'usage'}}
              className={window.location.hash === '#usage' ? 'active' : ''}
            >
              Начало использования системы
            </li>
            <li 
              onClick={() => {window.location.hash = 'regions'}}
              className={window.location.hash === '#regions' ? 'active' : ''}
            >
              Выбор регионов, по которым хотите получать заявки
            </li>
            <li 
              onClick={() => {window.location.hash = 'proposed-cases'}}
              className={window.location.hash === '#proposed-cases' ? 'active' : ''}
            >
              Получение новых заявок
            </li>
            <li 
              onClick={() => {window.location.hash = 'applications'}}
              className={window.location.hash === '#applications' ? 'active' : ''}
            >
              Контроль заявок
            </li>
            <li 
              onClick={() => {window.location.hash = 'procedures'}}
              className={window.location.hash === '#procedures' ? 'active' : ''}
            >
              Управление процедурами
            </li>
            <li 
              onClick={() => {window.location.hash = 'disagreement'}}
              className={window.location.hash === '#disagreement' ? 'active' : ''}
            >
              Что если я не согласен с назначением?
            </li>
            <li 
              onClick={() => {window.location.hash = 'account'}}
              className={window.location.hash === '#account' ? 'active' : ''}
            >
              Анкета
            </li>
            <li 
              onClick={() => {window.location.hash = 'membership-fees'}}
              className={window.location.hash === '#membership-fees' ? 'active' : ''}
            >
              Членские и целевые взносы
            </li>
            <li 
              onClick={() => {window.location.hash = 'notifications'}}
              className={window.location.hash === '#notifications' ? 'active' : ''}
            >
              Настройка уведомлений
            </li>
            <li 
              onClick={() => {window.location.hash = 'password-reset'}}
              className={window.location.hash === '#password-reset' ? 'active' : ''}
            >
              Как восстановить доступ к учетной записи
            </li>
            <li 
              onClick={() => {window.location.hash = 'safety'}}
              className={window.location.hash === '#safety' ? 'active' : ''}
            >
              Безопасность
            </li>
            <li 
              onClick={() => {window.location.hash = 'support'}}
              className={window.location.hash === '#support' ? 'active' : ''}
            >
              Как обратиться в поддержку
            </li>
        </ul>
      </div>

      <div className={styles.main}>
        <span id='info' style={{height: '50px'}}></span>
        <h2>Основная информация по безопасному использованию системы Личного кабинета</h2>
        <p>Вход в систему Личного кабинета должен производиться только с официального сайта Союза «СОАУ «Альянс»  по кнопке, которая находится справа сверху на главной странице сайта.</p>
        <img src='/img/help/alians009-index.png' alt='Изображение' />
        <WarningPanel text={'Никогда не переходите по ссылкам из писем и иных источников, которые якобы ведут на ресурсы Личного кабинета. Сотрудники СРО никогда не отправляют прямые ссылки на материалы Личного кабинета.'} type={'error'} />


        <span id='registration' style={{height: '50px'}}></span>
        <h2>Как зарегистрироваться</h2>
        <p>После перехода на главную страницу Личного кабинета нажмите кнопку "Зарегистрироваться". Кнопка может выглядеть следующим образом:</p>
        <p>1:</p>
        <img src='/img/help/registration-button-1.png' alt='Изображение' />
        <p>2:</p>
        <img src='/img/help/registration-button-2.png' style={{width: '40%'}} alt='Изображение' />
        <p>3:</p>
        <img src='/img/help/registration-button-3.png' style={{width: '40%'}} alt='Изображение' />
        <p>Введите ваш адрес электронной почты — он должен быть рабочим и внесённым в реестр СРО. На введённый адрес электронной почты будут приходить все заявки, предлагаемые вам СРО, сообщения и иные рабочие письма от СРО.</p>
        <img src='/img/help/registration-email.png' alt='Изображение' />
        <p>После ввода адреса электронной почты и нажатия кнопки "Зарегистрироваться" снизу вам предложат ввести проверочный код, отправленный на email, который вы указали на предыдущей странице.</p>
        <WarningPanel text={'Это нужно, потому что мы должны убедиться, что почта принадлежит именно Вам.'} type={'warning'} />
        <img src='/img/help/registration-verification-code.png' alt='Изображение' />
        <p>Не пришел код? Перейдите по следующей кнопке, чтобы просмотреть варианты решения проблемы:</p>
        <a className='aWithLink' onClick={() => scrollToSection('problems-with-code')}>Перейти к разделу "Что делать если код не пришел?"</a>
        <p>После успешного ввода проверочного кода и нажатия на кнопку "Подтвердить код" остается последний шаг: введите свое ФИО, пол и придумайте надежный пароль.</p>
        <WarningPanel text={'Не используйте легкий пароль или пароль от других сервисов. Это может быть небезопасно.'} type={'error'} />
        <p>Нажмите кнопку "Завершить регистрацию" снизу. Затем, если ваш адрес электронной почты уже существует в системе, вы сразу попадете в свой личный кабинет. Если нет — вам выведется сообщение о том, что регистрация прошла успешно: после подтверждения регистрации аппаратом СРО вы сможете войти в систему.</p>
        <img src='/img/help/registration-end.png' alt='Изображение' />
        <p>О возможности войти в систему, если вы еще не вошли, придет письмо на адрес электронной почты, указанный при регистрации.</p>
        <p>Обратите внимание, что на данный момент система не предусматривает регистрацию помощников арбитражных управляющих. Возможность использования системы есть только у аппарата СРО и управляющих, состоящих на сегодняшний день в Союзе «СОАУ «Альянс».</p>


        <span id='problems-with-code' style={{height: '50px'}}></span>
        <h2>Что делать если код не пришел?</h2>
        <WarningPanel text={'Код должен прийти со следующего адреса: otbor@alians009.ru.'} type={'warning'} />
        <p>Код почти наверняка должен прийти на указанный адрес электронной почты. В отдельных случаях при большой нагрузке необходимо немного подождать — от 5 до 15 минут.</p>
        <p>Письмо должно выглядеть следующим образом:</p>
        <img src='/img/help/registration-email-v-code.png' alt='Изображение' />
        <p>Если письма с проверочным кодом все равно нет в почте, проверьте все возможные папки и особенно "Спам". Некоторые почтовые сервисы могут ошибочно помечать такие письма как спам.</p>
        <p>Попробуйте найти в поиске вашего почтового клиента все письма от otbor@alians009.ru. Это может помочь найти нужное письмо, если почтовый сервис некорректно его обозначил и не показал во Входящих.</p>
        <p>Если вы нашли письмо, перейдите в контекстное меню и нажмите "Не спам!" или похожую кнопку, чтобы следующие письма от Личного кабинета Альянс приходили во Входящие.</p>
        <p>Если письмо все равно не пришло, напишите в поддержку по следующей ссылке:</p>
        <a href="/send-feedback" className='aWithLink'>Оставить обращение в поддержку</a>


        <span id='usage' style={{height: '50px'}}></span>
        <h2>Начало использования системы</h2>
        <p>Система Личного кабинета арбитражных управляющих Альянс разработана, чтобы упростить, систематизировать и оцифровать документооборот арбитражного управляющего, а также сделать взаимодействие управляющего и аппарата СРО более быстрым и прозрачным.</p>
        <p>Обязательным условием использования системы является наличие актуального согласия на обработку персональных данных между Вами и Союзом «СОАУ «Альянс». При первом входе в уже зарегистрированный личный кабинет вас попросят прикрепить этот документ.</p>
        <img src='/img/help/essential-data-pd.png' alt='Изображение' />
        <p>Далее необходимо прикрепить скан личной подписи (можно нарисовать мышкой от руки в интерфейсе системы). Эта подпись необходима для дальнейшей автоматической подстановки в документы согласия на ведение дела и другие документы. Аппарат СРО не имеет и не будет иметь возможности автоматически создавать такие документы за Вас. Такой автоматически сформированный документ призван упростить вам работу с документами.</p>
        <img src='/img/help/essential-data-signature.png' alt='Изображение' />
        {/* <p>Если хотите узнать больше об автоматически сформированных документах перейдите по кнопке ниже:</p>
        <a href="" className='aWithLink'>Автоматически сформированные документ</a> */}
        <p>Также необходимо придумать 6-значный код, который потребуется в случае утери доступа к учетной записи. Не забудьте его сохранить в безопасном месте.</p>
        <img src='/img/help/essential-data-verification-code.png' alt='Изображение' />
        <p>Страница "Главная" отображает основные показатели вашей учетной записи: сколько заявок и процедур вы сейчас ведете и отслеживаете, прикрепили ли все документы в срок и т. д.</p>
        <img src='/img/help/home.png' alt='Изображение' />


        <span id='regions' style={{height: '50px'}}></span>
        <h2>Выбор регионов, по которым хотите получать заявки</h2>
        <p>Теперь получение заявок от СРО происходит только через Личный кабинет. Чтобы вам приходили заявки, вы должны выбрать регионы, по которым хотите получать дела.</p>
        <p>Сделать это можно, перейдя на страницу "Анкета" (нажав в навигационном меню слева на свое ФИО), а затем выбрав сверху вкладку "Регионы ведения дел".</p>
        <p>Как перейти на страницу "Анкета":</p>
        <img src='/img/help/how-to-open-account-page.png' alt='Изображение' />
        <p>Как выбрать регионы ведения дел:</p>
        <img src='/img/help/am-regions-picker.png' alt='Изображение' />
        <p>Нажмите на тумблер по нужным регионам, и с этого момента вы будете включены во все последующие рассылки заявок по данным регионам.</p>


        <span id='proposed-cases' style={{height: '50px'}}></span>
        <h2>Получение новых заявок</h2>
        <p>Для того чтобы начать использование системы, перейдите во вкладку "Витрина заявок" слева в навигационном меню (в мобильной версии сайта сначала необходимо перейти по кнопке "Перейти в меню" снизу на экране).</p>
        <img src='/img/help/how-to-open-proposed-cases-page.png' alt='Изображение' />
        <p>Витрина отображает все ваши заявки, которые на данный момент СРО предлагает вам к ведению.</p>
        <img src='/img/help/am-proposed-cases-page.png' alt='Изображение' />
        <p>У каждой заявки есть дата рассылки и конечный срок предоставления согласия, до которого аппарат СРО принимает документы согласия на ведение дела.</p>
        <p>Чтобы прикрепить свое согласие на ведение интересующего дела, нажмите кнопку "Прикрепить согласие". Если кнопка отсутствует, значит либо управляющий уже выбран, либо срок предоставления согласий истек.</p>
        <img src='/img/help/how-to-send-case-agreement.png' alt='Изображение' />
        <p>После нажатия на кнопку вам откроется окно с краткой информацией по делу и полем прикрепления документа согласия.</p>
        <img src='/img/help/add-case-agreement-modal.png' alt='Изображение' />
        <p>Система Личного кабинета предлагает автоматическое заполнение шаблона документа согласия в форматах docx и pdf. При нажатии на соответствующую кнопку на ваше устройство загрузится файл с заполненными полями и вставленной вашей подписью.</p>
        <p>Можете исправить поля, если что-то не так, или сразу прикрепить файл согласия.</p>
        <p>Теперь данная заявка не отображается в разделе "Витрина заявок" — она перешла на страницу "Мои заявки". На эту страницу можно перейти из навигационного меню слева (в мобильной версии сайта сначала необходимо перейти по кнопке "Перейти в меню" снизу на экране).</p>


        <span id='applications' style={{height: '50px'}}></span>
        <h2>Контроль заявок</h2>
        Как перейти на страницу "Мои заявки":
        <img src='/img/help/how-to-open-am-applications-page.png' alt='Изображение' />
        Страница "Мои заявки":
        <img src='/img/help/am-applications-page.png' alt='Изображение' />
        <p>На данной странице собраны все заявки, на которые вы отправили документ согласия.</p>
        <p>Если вы передумали, то всегда можете прикрепить файл отзыва согласия или загрузить новый документ согласия. Аппарат СРО увидит все прикрепленные файлы.</p>
        <p>Для этого просто перейдите по кнопке "Прикрепить новый документ". Если этой кнопки нет, то либо аппарат СРО уже выбрал кандидатуру, либо крайний срок предоставления согласий истек.</p>
        <img src='/img/help/add-new-doc-application-modal.png' alt='Изображение' />

        <span id='procedures' style={{height: '50px'}}></span>
        <h2>Управление процедурами</h2>
        <p>На странице "Процедуры" (можно перейти из навигационного меню слева) видны все карточки (заявки/дела), в которых вы прикреплены аппаратом СРО как управляющий.</p>
        <img src="/img/help/procedures-page.png" alt="Изображение" />
        <p>Нажатием на строку таблицы вы можете перейти в карточку. Здесь отображены все данные о заявке/деле.</p>
        <img src="/img/help/case-page.png" alt="Изображение" />
        <WarningPanel text={'Иногда система будет вам подсказывать, что необходимо внести и до какого срока.'} type={'warning'} />
        <p>Чтобы изменить или внести новые данные в карточку, необходимо сверху нажать кнопку "Изменить данные".</p>
        <p>1:</p>
        <img src="/img/help/how-to-change-case-data-1.png" alt="Изображение" />
        <p>2:</p>
        <img src="/img/help/change-case-page.png" alt="Изображение" />
        <p>Сверху расположены вкладки "Отчетность" и "Дополнительное страхование", которые необходимо заполнить.</p>
        <p>Вкладка "Отчетность" открывается только после перевода статуса карточки в "В работе (Управляющий назначен)".</p>
        <img src="/img/help/accounting-case.png" alt="Изображение" />
        <img src="/img/help/additional-insurance-case.png" alt="Изображение" />


        <span id='disagreement' style={{height: '50px'}}></span>
        <h2>Что если я не согласен с назначением?</h2>
        <p>Об этом необходимо сообщить аппарату СРО через систему Личного кабинета.</p>
        <p>Для этого перейдите в нужную карточку и в самом конце страницы нажмите кнопку "Отказаться от назначения". В сообщения карточки добавится запись о вашем намерении, а аппарату СРО придет уведомление.</p>
        <img src="/img/help/how-to-add-refusal-appointment.png" alt="Изображение" />


        <span id='account' style={{height: '50px'}}></span>
        <h2>Анкета</h2>
        <p>Заполните основные данные личной учётной записи — для этого в навигационном меню слева нажмите по своему ФИО.</p>
        <img src="/img/help/account-page.png" alt="Изображение" />
        <p>Анкета предполагает сбор всей информации, необходимой для взаимодействия арбитражного управляющего с СРО.</p>

        <span id='membership-fees' style={{height: '50px'}}></span>
        <h2>Членские и целевые взносы</h2>
        <p>
          В личном кабинете вы всегда можете просматривать и контролировать собственный баланс в СРО
          по членским и целевым взносам: для этого перейдите на страницу «Членские взносы» из
          навигационного меню слева.
        </p>
        <img src='/img/help/how-to-open-am-membership-page.png' alt='Изображение' />
        <img src='/img/help/membership-fees-page.png' alt='Изображение' />
        <p>
          У каждого управляющего есть возможность просматривать свой баланс по взносам, а также
          посмотреть актуальные реквизиты для оплаты и удобный QR-код. При сканировании его камерой
          в банковском приложении система автоматически подставит необходимые поля в платёж — вам
          останется только указать сумму и назначение платежа.
        </p>
        <WarningPanel text='Оплата членских и целевых взносов в СРО по-прежнему осуществляется через выставление счёта. Оплата через QR-код в личном кабинете является дополнительным способом.' type='warning' />
        <WarningPanel text='Обратите внимание: обновлённый баланс в личном кабинете может отображаться с задержкой. Каждый платёж по-прежнему проходит через бухгалтерию СРО и затем выгружается в систему.' type='error' />

        <span id='notifications' style={{height: '50px'}}></span>
        <h2>Настройка уведомлений</h2>
        <p>Вы всегда можете настроить уведомления, которые приходят на страницу "Уведомления" (можно перейти из навигационного меню слева).</p>
        <p>Для этого войдите в личный кабинет и нажмите в навигационном меню слева снизу кнопку "Настройки". Во вкладке "Общие настройки" будут отображаться тумблеры по отдельным категориям обновлений — отредактируйте список на свое усмотрение.</p>
        <img src="/img/help/how-to-open-settings.png" alt="Изображение" />
        <img src="/img/help/settings-modal.png" alt="Изображение" />
        <p>Обратите внимание: отказ от получения уведомлений на почту не приведет к тому, что вы перестанете получать новые предлагаемые заявки на странице "Витрина заявок".</p>
        

        <span id='password-reset' style={{height: '50px'}}></span>
        <h2>Как восстановить доступ к учетной записи</h2>
        <p>Если вы забыли пароль к своей учётной записи Личного кабинета, то перейдите на страницу восстановления пароля:</p>
        <a className='aWithLink' href="/auth/reset-password">Перейти к восстановлению пароля</a>
        <p>Вам предложат ввести email, связанный с вашей учётной записью, и подтвердить, что именно вы являетесь владельцем учётной записи.</p>

        <span id='safety' style={{height: '50px'}}></span>
        <h2>Безопасность</h2>
        <WarningPanel text={'Обязательно ознакомьтесь с информацией о безопасности в этом разделе. Здесь указаны рекомендации и предупреждения от Союза «СОАУ «Альянс»'} type={'error'} />
        <p>
          Мошенники нередко рассылают письма, маскируясь под сотрудников или руководство СРО. Прежде чем переходить по ссылкам, скачивать вложения или совершать какие-либо действия по просьбе из письма — всегда проверяйте, с какого адреса оно пришло.
        </p>
        <p>
          Официальный email СРО использует единый домен (домен — это часть адреса электронной почты после знака "@"):
        </p> 
        <Link 
          className='aWithLink'
          to="https://alians009.ru" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          alians009.ru
        </Link> 
        <p>Никакие другие адреса СРО не использует.</p>
        <p>Если письмо пришло с любого другого домена — даже внешне очень похожего — не доверяйте его содержимому.</p>
        <p>Мошенники часто подменяют похожие символы в адресе, чтобы домен выглядел настоящим на первый взгляд: например, латинскую букву «l» (эль) заменяют на заглавную «I» (ай) или цифру «1», используют кириллические буквы вместо похожих латинских, добавляют лишние символы или поддомены. Внимательно сверяйте адрес отправителя посимвольно в вашем почтовом клиенте, а не полагайтесь на отображаемое имя — оно может быть любым и никак не подтверждает подлинность отправителя.</p>
        <p>Список официальных адресов электронной почты СРО, с которых приходят письма, можно уточнить на официальном сайте СРО или на этой странице:</p>
        <ul>
          <li>info@alians009.ru</li>
          <li>otbor@alians009.ru</li>
          <li>legal@alians009.ru</li>
          <li>control@alians009.ru</li>
          <li>rule@alians009.ru</li>
        </ul>
        <h2>Как быстро проверить подлинность письма?</h2>
        <h2 style={{marginBottom: '0px', marginTop: '0px'}}>1 способ:</h2>
        <p>Самый простой и удобный способ — это скопировать email и вставить его на следующей странице Личного кабинета:</p>
        <Link
          className='aWithLink'
          to='/safety/email-authentication'
        >
          Перейти на страницу проверки подлинности email
        </Link>
        <p>Страница будет выглядеть следующим образом:</p>
        <img src="/img/help/email-authentication-page.png" alt="Изображение" />

        <span style={{height: '30px'}}></span>
        <h2 style={{marginBottom: '0px', marginTop: '0px'}}>2 способ:</h2>
        <p>Проверка подлинности письма вручную.</p>
        <p>Пример подлинного письма от СРО:</p>
        <img src="/img/help/real-email-example-1.png" alt="Изображение" />
        <p>Чтобы проверить поля перейдите по стрелке или похожей кнопке в вашем почтовом клиенте, чтобы увидеть полные данные письма, включая адрес отправителя.</p>
        <img src="/img/help/real-email-example-2.png" alt="Изображение" />
        <p>Письмо пришло с официального домена, в нем нет подозрительных ссылок и вложений, а также оно содержит корректную информацию в поле "От".</p>

        <p>Пример мошеннического письма:</p>
        <img src="/img/help/fake-email-1.png" alt="Изображение" />
        <p>Также переходим по стрелке или похожей кнопке в вашем почтовом клиенте, чтобы увидеть полные данные письма, включая адрес отправителя.</p>
        <img src="/img/help/fake-email-2.png" alt="Изображение" />
        <p>Обратите внимание, как в этом письме отправитель указан неверно. В данном примере мошенник использовал поддельный адрес, в котором вместо латинской буквы "i" (ай) используется похожая буква "l" (эль) и вместо второй цифры 0 использовал букву "O". Это видно, поскольку символы слегка разные по ширине. Таким образом имя почты получилось allans0O9.ru (алланс ноль буква О девять), вместо alians009.ru (альянс ноль ноль девять).</p>
        <img src="/img/help/fake-email-3.png" alt="Изображение" />
        <p>Можно дополнительно просмотреть поле "Подписан". В почтовом клиенте Gmail в случае подлинного письма там будет указан настоящий адрес сайта, а в случае мошеннического письма — будет указан другой адрес.</p>
        <p>Проверка поля "Подписан" может работать не во всех клиентах - Яндекс, например, оставляет поле пустым.</p>
        <img src="/img/help/real-email-example-3.png" alt="Изображение" />
        <img src="/img/help/real-email-example-4.png" alt="Изображение" />
        <p>Если у вас есть хоть малейшие сомнения в подлинности письма — не отвечайте на него и не выполняйте указанные в нём действия. Позвоните в СРО по номеру телефона с официального сайта и уточните информацию напрямую.</p>
        <p>Никогда не переводите денежные средства на личные счета по просьбе из письма. Если письмо якобы пришло с личной почты директора, заместителя директора или другого сотрудника СРО с просьбой срочно оплатить счёт по указанным в письме реквизитам — это признак мошенничества. Официальные платёжные операции никогда не запрашиваются подобным образом.</p>
        <p>Будьте внимательны и в случае сомнений всегда уточняйте информацию напрямую в СРО, а не через письмо, вызвавшее подозрение.</p>

        <span id='support' style={{height: '50px'}}></span>
        <h2>Как обратиться в поддержку</h2>
        <p>Если у Вас остались вопросы — Вы всегда можете обратиться в поддержку. Это можно сделать с любого экрана системы, нажав кнопку "Обратиться в поддержку".</p>
        <p>Если вы уже вошли в учётную запись, то можете увидеть соответствующую кнопку слева снизу в навигационном меню.</p>
        <img src="/img/help/how-to-open-send-feedback.png" alt="Изображение" />
        <p>Если же вы еще не зашли или не смогли зайти в учётную запись, то на первой странице перейдите по следующим разделам:</p>
        <img src="/img/help/how-to-open-send-feedback-4.png" alt="Изображение" />
        <img src="/img/help/how-to-open-send-feedback-2.png" style={{width: '40%'}} alt="Изображение" />
        <img src="/img/help/how-to-open-send-feedback-3.png" style={{width: '40%'}} alt="Изображение" />
        <p>Обращение можно также оставить по кнопке ниже:</p>
        <a className='aWithLink' href="/send-feedback">Отправить обращение в поддержку</a>


        <span style={{height: '50px'}}></span>
        <p>Спасибо за использование Личного кабинета арбитражных управляющих Союза «СОАУ «Альянс».</p>
        <span style={{height: '50px'}}></span>
      </div>
    </div>
  )
}
